import { BenefitPageApiError } from '../domain/errors/BenefitPageApiError';
import { BenefitTileApiError } from '../domain/errors/BenefitTileApiError';
import { NotLoggedInError } from '../domain/errors/NotLoggedInError';
import { BillCheckCreationFlowError } from '@/domain/errors/BillCheckCreationFlowError';

export const shouldForwardErrorToErrorBoundary = (error: Error | unknown) => {
  return !(
    error instanceof NotLoggedInError ||
    error instanceof BenefitPageApiError ||
    error instanceof BenefitTileApiError ||
    error instanceof BillCheckCreationFlowError
  );
};
